<template>
  <div class="tableContentSlot">
    
    <img :src="baseUrl+scope.scope.systemFile.filePath" alt="" v-if="scope.scope.systemFile && Object.keys(scope.scope.systemFile).length > 0"/>
    <!-- <img src="../../../../../../public/static/noImg.png" alt="" v-else /> -->
    <div class="name">
      <div>{{scope.scope.title}}</div>
      <div>{{scope.scope.summary}}</div>
    </div>
  </div>
</template>
<script>
const baseUrl = process.env.VUE_APP_BASE_IMGURL
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data () {
    return {
      baseUrl
    }
  },
   mounted(){
   }
}
</script>